<div data-test="1248ukjb" class="dropdown date-switch__dropdown p-0" UIKitDropdownMenu>
  <div data-test="Tv5uQs2D" class="dropdown__wrap">
    <ul data-test="bk0GG4KC" class="dropdown__menu">
      <li
        data-test="z7rNGgqa"
        class="dropdown__menu-item"
        *ngFor="let item of list"
        [ngClass]="{
          'has-dropdown': item.sublist,
          checked: selectedItem === item.name
        }"
        (click)="!item.sublist ? selectItem(item.name) : ''"
      >
        <a data-test="uTBBYFEt" class="dropdown__menu-link">{{ item.name }}</a>
        <div data-test="-2xMfLYT" class="dropdown dropdown_child" *ngIf="item.sublist">
          <div data-test="yQ2P70lt" class="dropdown__wrap">
            <input
              data-test="AIOrqFQ8"
              class="dropdown__input input input_xs"
              placeholder="Search ..."
              value=""
              type="text"
            />
            <ul data-test="tPfzUeOt" class="dropdown__menu">
              <li
                data-test="j1f8K5kV"
                class="dropdown__menu-item"
                *ngFor="let subitem of item.sublist"
                (click)="selectItem(subitem.name)"
              >
                <a data-test="KtvGGI-I" class="dropdown__menu-link" href="">
                  {{ subitem.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
